import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=479d7e01&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d7e01",
  null
  
)

export default component.exports